// extracted by mini-css-extract-plugin
export default {"closeButton":"Popup_closeButton__iKvZW","wrapper":"Popup_wrapper__gjV0g"};